module.exports = __webpack_public_path__ + "ui-bg_gloss-wave_35_f6a828_500x100.png";


//////////////////
// WEBPACK FOOTER
// ./ui/src/vendor/jquery-ui/css/ui-lightness/images/ui-bg_gloss-wave_35_f6a828_500x100.png
// module id = 803
// module chunks = 1